
<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: {
    dataSet: Array,
    dataColor: Array,
    dataLabels: Array,
  },
  data() {
    const _this = this
    return {
      chartData: {
        labels: this.dataLabels,
        datasets: this.dataSet,
      },
      options: {

        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 70,
        onClick: function (evt, item) {
         // console.log(item.length > 1)
          if(item.length > 0){
             var activePoint = this.getElementsAtEvent(evt);
          var curr_item = item[0]._chart.data.labels[activePoint[0]['_index']]
         // console.log(curr_item)
          if (curr_item == "ขยะติดเชื้อ") {
            item[0]._chart.data.datasets[0].data = [22.8, 33.8, 6.8, 26.9]
            item[0]._chart.data.datasets[0].backgroundColor = ["#AB47BC", "#8E24AA", "#7B1FA2", "#6A1B9A"]
            item[0]._chart.data.labels = ['ไซรีน', 'ยาฆ่าเชื้อ', 'โพรเพน', 'คาบอน']
            _this.$parent.$parent.pineChartDrill();
            this.update()
          }
         }
         


          // console.log();
        },
        legend: {
          position: "right",
          //fullWidth:true,
          labels: {
            fontColor: "black",
            padding: 15,
            //boxWidth:100

          },

        },
        legendCallback(chart) {
          var legendHtml = [];
          legendHtml.push("<ul>");
          var item = chart.data.datasets[0];
          for (var i = 0; i < item.data.length; i++) {
            legendHtml.push("<li>");
            legendHtml.push('<span class="chart-legend" style="background-color:' + item.backgroundColor[i] + '"></span>');
            legendHtml.push('<span class="chart-legend-label-text">' + item.data[i] + " person - " + chart.data.labels[i] + " times</span>");
            legendHtml.push("</li>");
          }

          legendHtml.push("</ul>");
          //console.log(legendHtml.join(""))
          return legendHtml.join("");
        }
      }
    }
  },

  mounted() {
    this.addPlugin({
      id: 'my-plugin',
      beforeInit: function (chart, options) {
      
        chart.legend.afterFit = function () {
          this.width = this.width + 50;
        };
      },
      beforeDraw: function (chart) {

        let total = chart.data.datasets[0].data.reduce((a, b) => {
          return a + b;
        });

        chart.legend.legendItems.forEach(
          (label) => {
            let value = chart.data.datasets[0].data[label.index];
            // console.log(label.index)
            label.text = chart.data.labels[label.index] + ' - ' + (value / total * 100).toFixed(0) + '%'
            return label;
          }

        )

      }
    })
    this.renderChart(this.chartData, this.options);
    this._data._chart.generateLegend()
  },
  methods: {
    reRender(labels, data) {

      this.chartData.labels = labels
      this.chartData.datasets = data
      this._data._chart.destroy();
      this.renderChart(this.chartData, this.options);
      // console.log(data)
    }
  },
};
</script>
